import { Api } from "../axios-config";
import { TJwtToken } from '../usuario/auth/AuthService';
import jwt_decode from "jwt-decode";


export interface ITemp {
    idTemp: number,
    codigo: number,
    corrente: number,
    intermediaria: number,
    eliminacao: boolean,
    obs: string       
}

//dados get
export interface IListagemTipo {
    idTipo: number,
    nomeTipo: string,
    nivel: number,
    idSetor: number,
    idTipoPai: number,
    tipo_indices: IListagemTipo_Indices[],
    tipos: IListagemTipo[];
}

export interface ITipo {
    idTipo: number,
    nomeTipo: string,
    hierarquia: string,
    nivel: number,
    estado: true,
    idSetor: number,
    idTipoPai: number,
    tipo_indices: IListagemTipo_Indices[],
}

export interface IListagemTipo_Indices {
    idTipo_indice: number,
    indice: IListagemIndices,
}
export interface IListagemIndices {
    idIndice: number,
    nomeIndice: string,
}

export interface RenderTree {
    idTipo: number;
    nomeTipo: string;
    tipos?: readonly RenderTree[];
    nivel: number;
    idSetor: number;
}

export interface RenderTreeIndice {
    idIndice: number;
    nomeIndice: string;
}

//dados post
type Nullable<T> = T | null;
export interface INovoTipo {
    idTipo: number,
    nomeTipo: string,
    nivel: number,
    idSetor: number,
    idTipoPai: Nullable<number>,
}

export interface IDetalheTipo {
    idTipo: number,
    nomeTipo: string,
    temporalidade?: ITemp,
}

const getByIdSetor = async (
    idSetor: number,
    indice_caixa?: boolean,
    estado?: boolean
): Promise<IListagemTipo[] | Error> => {
    const token = localStorage.getItem("ACESS_TOKEN");
    let visao: string | undefined;
    let idUsuario: number | undefined;

    if (token !== null) {
        const decoded: TJwtToken = jwt_decode(token);
        visao = decoded.role;
        idUsuario = Number(decoded.name);
    }

    try {
        let url: string;

        if (indice_caixa === null || indice_caixa === undefined) {
            url = `Tipo/idSetor?idSetor=${idSetor}&estado=${estado}`;
        } else {
            url = `Tipo/idSetor?idSetor=${idSetor}&indice_caixa=${indice_caixa}`;
        }

        if (visao !== "master" && visao !== "clienteGestor") {
            if (indice_caixa === undefined || indice_caixa === null) {
                url = `Permissao/pesquisaPermissaoPorUsuario?idUsuario=${idUsuario}&idSetor=${idSetor}`;
            } else {
                url = `Permissao/pesquisaPermissaoPorUsuario?idUsuario=${idUsuario}&idSetor=${idSetor}&indice_caixa=${indice_caixa}`;
            }
        }

        const { data } = await Api.get(url);

        if (!data) {
            return new Error("Erro ao listar os registros");
        }

        // Normaliza os dados vindos da API
        const dados: IListagemTipo[] = data.map((row: any) => ({
            idTipo: row.idTipo,
            idTipoPai: row.idTipoPai,
            nomeTipo: row.nomeTipo,
            nivel: row.nivel,
            idSetor: row.idSetor,
        }));

        // Mapeia cada idTipo para o índice no array
        const idMapping: Record<number, number> = dados.reduce(
            (acc, el, i) => {
                acc[el.idTipo] = i;
                return acc;
            },
            {} as Record<number, number>
        );

        let raiz: IListagemTipo[] = [];

        dados.forEach((el) => {
            if (el.idTipoPai === null) {
                // É raiz
                raiz.push(el);
                return;
            }

            const parentIndex = idMapping[el.idTipoPai];
            if (parentIndex === undefined) {
                console.warn(
                    `Pai com idTipo=${el.idTipoPai} não encontrado para filho idTipo=${el.idTipo}`
                );
                // Se não achar o pai, trata como raiz também
                raiz.push(el);
                return;
            }

            const parentEl = dados[parentIndex];
            if (!parentEl.tipos) parentEl.tipos = [];
            parentEl.tipos.push(el);
        });

        return raiz;
    } catch (error: any) {
        console.error(error);
        return new Error(error?.message || "Erro ao listar os registros");
    }
};

const toggleEnabledById = async (idTipo: number): Promise<void | Error> => {
    try {
        await Api.patch(`Tipo/alterarEstado?idTipo=${idTipo}`);// VERIFICAR SE URL BATE COM A PI
    } catch (error) {
        console.error(error);

        return new Error((error as { message: string }).message || 'Erro ao habilitar/desabilitar o registro');
    }
};


const create = async (dados: Omit<INovoTipo, 'idTipo'>): Promise<number | Error> => {
    try {
        const { data } = await Api.post<INovoTipo>('Tipo', dados);

        if (data) {
            return data.idTipo;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const getById = async (idTipo: number): Promise<IDetalheTipo | Error> => {
    try {
        const { data } = await Api.get(`Tipo/idTipo?idTipo=${idTipo}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const updateById = async (dados: IDetalheTipo): Promise<void | Error> => {
    try {
        await Api.put('Tipo', dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};

const deleteById = async (idTipo: number): Promise<void | Error> => {
    try {
        await Api.patch(`Tipo/alterarEstado?idTipo=${idTipo}`);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');

    }
};

const createTemp = async (temp: Omit<ITemp, 'idTemp'> , idTipo: number): Promise<void | Error> => {
    try
    {
        await Api.post(`Temporalidade?idTipo=${idTipo}`, temp);
    }
    catch (error) 
    {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');

    }
}

const updateTemp = async (temp: Omit<ITemp, 'idTemp'>): Promise<void | Error> => {
    try
    {
        await Api.put(`Temporalidade`, temp);
    }
    catch (error) 
    {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');

    }
}

export const TipoService = {
    getByIdSetor,
    toggleEnabledById,
    create,
    getById,
    updateById,
    deleteById,
    createTemp,
    updateTemp,
}